import { render } from "./AttendanceConfiguration.vue?vue&type=template&id=ac0e6dbc&scoped=true"
import script from "./AttendanceConfiguration.vue?vue&type=script&lang=js"
export * from "./AttendanceConfiguration.vue?vue&type=script&lang=js"

import "./AttendanceConfiguration.vue?vue&type=style&index=0&id=ac0e6dbc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0e6dbc"]])

export default __exports__